import { c as _c } from "react/compiler-runtime";
import { StacksFilled } from "../../icons";
import { Badge } from "./Badge";
export function QuantityBadge(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      iconSize: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const iconSize = t1 === undefined ? 14 : t1;
  let t2;
  if ($[5] !== children || $[6] !== className || $[7] !== iconSize || $[8] !== rest) {
    t2 = <Badge className={className} {...rest} icon={StacksFilled} iconSize={iconSize}>{children}</Badge>;
    $[5] = children;
    $[6] = className;
    $[7] = iconSize;
    $[8] = rest;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}